export default "__VITE_ASSET__cxClQuCs__"